import type { HTMLAttributes } from 'react';

// Vite raw import — SVG markup as a string so we can inline it and let
// `currentColor` paths inherit from the parent's text colour. Co-located
// with the component so it's bundled into the JS rather than shipped as a
// redundant static asset. Copied from dataset-search-frontend.
import logoSvg from './senscience-logo.svg?raw';

import { cn } from '~lib/utils/style';

interface LogoProps extends HTMLAttributes<HTMLAnchorElement> {
  href?: string;
}

function Logo({ className, href = '/', ...props }: LogoProps) {
  return (
    <a
      href={href}
      aria-label="SENSCIENCE"
      className={cn(
        'inline-flex items-center text-foreground transition-colors hover:text-primary',
        className,
      )}
      {...props}
    >
      <span
        // Inline SVG so currentColor reaches the embedded paths.
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: logoSvg }}
        className="block h-7 w-auto [&>svg]:block [&>svg]:h-full [&>svg]:w-auto"
      />
    </a>
  );
}

export { Logo };
